
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class StepList extends Vue {
  @Prop({ default: () => [] })
  data: any;
  @Prop({ default: 0 })
  total: number | string;
  @Prop({ default: false })
  logistics: boolean;
  get $data() {
    return this.data;
  }
  isLoadMore: boolean = false;
  loadMore() {
    this.$emit("loadMore");
    if (this.total === 0) {
      this.isLoadMore = !this.isLoadMore;
    } else {
      this.isLoadMore = true;
    }
  }
}
